import { render } from "./CrearEnfermero.vue?vue&type=template&id=fbc6cc2e&scoped=true"
import script from "./CrearEnfermero.vue?vue&type=script&lang=js"
export * from "./CrearEnfermero.vue?vue&type=script&lang=js"

import "./CrearEnfermero.vue?vue&type=style&index=0&id=fbc6cc2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbc6cc2e"]])

export default __exports__